import { createBrowserRouter } from "react-router-dom"
import Blog from "../components/Blog";
import Home from "../components/Home/Home";
import ProjectDetails from "../components/ProjectDetails";
import Main from "./Main/Main"

const router = createBrowserRouter([
    {
        path: '/',
        element: <Main></Main>,
        children: [
            {
                path: '/',
                element: <Home></Home>
            },
            {
                path: '/blog',
                element: <Blog />
            },
            {
                path: '/project/:id',
                element: <ProjectDetails />,
                loader: ({ params }) => fetch(`https://nahid-parvez-server.vercel.app/projects/${params.id}`)
            },
        ]
    }

])
export default router;